import { BaseModel } from '../../../Common/Basic/models/base.model';
import { RSSFeedApi } from '../../../api/rssFeed/models/rss-feed-api.model';

export class RSSFeed extends BaseModel<RSSFeed, RSSFeedApi> {
    id: number;
    name: string;

    description: string;
    url: string;
    maxItems: number;
    enabled: boolean;

    // readonly
    createdByUserId: number;
    createdDate: Date;

    lastModifiedByUserId: number;
    lastModifiedDate: Date;

    constructor(apiModel?: RSSFeedApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: RSSFeedApi) {
        this.id = apiModel.id;
        this.name = apiModel.name;

        this.description = apiModel.description;
        this.url = apiModel.url;
        this.maxItems = apiModel.maxItems;
        this.enabled = apiModel.enabled;

        this.createdByUserId = apiModel.createdUserId;
        this.createdDate = new Date(apiModel.createdDate);

        this.lastModifiedByUserId = apiModel.modifiedUserId;
        this.lastModifiedDate = new Date(apiModel.modifiedDate);
    }


    constructDefault() {
        this.enabled = true;
    }


    toApiModel(): RSSFeedApi {
        const apiModel: RSSFeedApi = {
            id: this.id,
            name: this.name,
            description: this.description,
            maxItems: this.maxItems,
            enabled: this.enabled
        };

        return apiModel;
    }

    clone(): RSSFeed {
        return new RSSFeed(this.toApiModel());
    }

    equals(other?: RSSFeed): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.description !== other.description) {
            return false;
        }

        if (this.url !== other.url) {
            return false;
        }

        if (this.maxItems !== other.maxItems) {
            return false;
        }

        if (this.enabled !== other.enabled) {
            return false;
        }

        return true;
    }
}
